import React, { useEffect } from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import withStyles from '@material-ui/core/styles/withStyles';
import backPack from 'Images/ownerfy-backpack-green-v3.jpg';
import heroImagePattern from 'Images/dotted-pattern.png';
import sticker from 'Images/sticker-web.png';
import stackedLogo from 'Images/logo-stacked.png';
import qrCode from 'Images/QR-code.png';
import luggageTag from 'Images/luggage-tag.jpg';
import handWithPhone from 'Images/holding-phone-cutout.png';
import ItemRowEntry from 'Components/ItemRowEntry';
import Page from 'Components/Page';
import { Link } from 'react-router-dom';
import MuiLink from '@material-ui/core/Link';
import history from '../history';
import clsx from 'clsx';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from 'Store/actions';
import Container from 'Components/Container';
import useMediaQuery from '@material-ui/core/useMediaQuery';

const pageStyles = theme => ({
  heroButtons: {
    marginTop: theme.spacing(4),
    marginBottom: 20,
  },
  heroContent: {
    position: 'relative',
    textAlign: 'center',
  },
  heroLimiter: {
    position: 'relative',
    maxWidth: '1620px',
    margin: 'auto',
    textAlign: 'initial',
  },
  heroTextContainer: {
    position: 'absolute',
    paddingLeft: '10.5%',
    paddingTop: '8%',
    [theme.breakpoints.down('md')]: {
      paddingLeft: '9%',
      paddingTop: '3%',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  sticker: {
    width: '134px',
    position: 'relative',
    top: '5px',
  },
  mobileHeroText: {
    position: 'absolute',
    color: '#1F1F1F',
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: '500',
    textTransform: 'uppercase',
    zIndex: '10',
    marginLeft: '11%',
    marginTop: '9%',
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileInfoContainer: {
    paddingTop: 45,
    paddingBottom: 65,
    [theme.breakpoints.up('md')]: {
      display: 'none',
    },
  },
  mobileInfoHeadline: {
    fontSize: '23px',
    lineHeight: '25px',
    fontWeight: 500,
    marginBottom: 25,
  },
  mobileInfoSplitContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
  mobileInfoLeftSide: {
    marginRight: 45,
  },
  mobileInfoCopy: {
    marginBottom: 20,
  },
  listProducts: {
    display: 'flex',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  foundSomething: {
    textAlign: 'left',
    color: theme.palette.secondary.main,
    marginLeft: 29,
  },
  reviewProduct: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '30px',
    },
  },
  heroImageContainer: {
    position: 'relative',
  },
  heroImage: {
    width: '100%',
    display: 'block',
    pointerEvents: 'none',
    [theme.breakpoints.down('sm')]: {
      clipPath: 'inset(10% 13% 24% 19%)',
      transform: 'scale(1.48) translateX(-2.8%)',
      marginBottom: '-8%',
      marginTop: '0%',
    },
  },
  heroHeadline: {
    color: theme.palette.secondary.main,
    fontSize: 60,
    lineHeight: '80px',
    fontWeight: 600,
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    [theme.breakpoints.down('md')]: {
      fontSize: 40,
      lineHeight: '40px',
    },
  },
  heroText: {
    color: theme.palette.secondary.main,
  },
  taglineContainer: {
    marginBottom: '25px',
    '@media (max-width: 374px)': {
      display: 'flex',
      flexDirection: 'column',
    },
  },
  tagline: {
    fontSize: 18,
    lineHeight: '32px',
    fontWeight: 400,
    color: '#1F1F1F',
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    marginRight: '30px',
    textTransform: 'uppercase',
  },
  lastTagline: {
    marginRight: 0,
  },
  pageWrapper: {
    background: 'transparent',
    paddingBottom: 0,
    overflow: 'hidden',
  },
  explanationArea: {
    backgroundColor: theme.palette.secondary.main,
    paddingBottom: '50px',
  },
  explanationContainer: {
    backgroundColor: theme.palette.light.main,
    borderRadius: 24,
    padding: '57px 100px',
    marginTop: '-140px',
    boxShadow: '0 20px 40px 0px rgba(0,0,0,0.2)',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      marginTop: 100,
      padding: 17,
    },
    // [theme.breakpoints.down('xs')]: {
    //   padding: '30px',
    // },
  },
  explanationHeadline: {
    marginBottom: '70px',
    marginTop: 0,
    color: '#009245',
    // [theme.breakpoints.down('sm')]: {
    //   fontSize: '35px',
    //   marginBottom: '40px',
    //   lineHeight: '40px',
    // },
    [theme.breakpoints.down('sm')]: {
      position: 'absolute',
      marginTop: '-91px',
      fontSize: '30px',
      lineHeight: '55px',
      color: '#ffffff',
    },
    [theme.breakpoints.down(374)]: {
      fontSize: '25px',
      textAlign: 'center',
      width: '100%',
      left: 0,
    },
  },
  explanationSteps: {
    display: 'flex',

    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  explanationGroup: {
    flex: 1,
    display: 'flex',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  leftExplanationGroup: {
    paddingRight: '70px',
    [theme.breakpoints.down('sm')]: {
      paddingRight: 0,
    },
  },
  explanationStep: {
    width: '50%',
    display: 'flex',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  explanationStep1: {
    marginBottom: '100px',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '80px',
    },
  },
  explanationStep2: {
    [theme.breakpoints.down('sm')]: {
      marginBottom: '80px',
    },
  },
  explanationStep4: {
    paddingLeft: '108px',
    [theme.breakpoints.down('sm')]: {
      paddingLeft: '80px',
    },
  },
  stepNumber: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.light.main,
    marginRight: '40px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: '700',
    fontSize: '36px',
    [theme.breakpoints.down('sm')]: {
      marginRight: '30px',
      width: '50px',
      height: '50px',
      fontSize: '30px',
    },
    '@media (max-width: 374px)': {
      marginRight: '20px',
    },
  },
  stepContent: {
    flex: 1,
  },
  explanationImage: {
    marginBottom: '10px',
  },
  explanationTitle: {
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    fontSize: '24px',
    fontWeight: '700',
    marginTop: 0,
    marginBottom: '0',
  },
  explanationBody: {
    color: '#9e9e9e',
    fontSize: '16px',
    lineHeight: '30px',
    marginTop: 10,
  },
  luggageTag: {
    width: '162px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '107px',
    },
  },
  stackedLogo: {
    width: '244px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '157px',
    },
  },
  qrCode: {
    width: '120px',
    maxWidth: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '105px',
    },
  },
  strongText: {
    fontFamily: ['"Work Sans"', 'sans-serif'].join(','),
    fontSize: '24px',
    textTransform: 'uppercase',
    marginBottom: '30px',
    fontWeight: '700',
    [theme.breakpoints.down('sm')]: {
      marginTop: '40px',
    },
  },
  foundItemArea: {
    backgroundColor: theme.palette.light.main,
  },
  foundItemContainer: {
    display: 'flex',
    marginLeft: '7%',
    paddingTop: '88px',
    marginRight: '3%',
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: '70px',
    },
  },
  foundItemTextContainer: {
    paddingBottom: '50px',
    width: '50%',
    [theme.breakpoints.down('md')]: {
      width: '50%',
    },
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  foundItemHeadline: {
    color: '#000000',
    fontSize: '60px',
    fontWeight: '600',
    lineHeight: '70px',
    marginBottom: '40px',
    marginTop: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: '40px',
      lineHeight: '55px',
    },
  },
  foundItemHeadlineEmphasis: {
    color: '#009245',
  },
  foundItemBodyStrong: {
    fontWeight: 600,
    fontSize: 20,
    marginBottom: '30px',
  },
  foundItemBody: {
    marginBottom: '60px',
    fontSize: 20,
    [theme.breakpoints.down('sm')]: {
      marginBottom: '30px',
    },
  },
  handWithPhone: {
    maxWidth: '420px',
    height: 'auto',
    width: 'auto',
    flex: 1,
    position: 'absolute',
    bottom: '0px',
    right: '90px',
    [theme.breakpoints.down('md')]: {
      maxWidth: '500px',
      right: '0px',
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  registerTagButtonContainer: {
    [theme.breakpoints.down('sm')]: {
      display: 'flex',
      marginBottom: 50,
    },
  },
});

function Home({ classes, setActiveModal, itemDraft, saveItemDraftInfo }) {
  // const jumpToHash = () => {
  //   console.log('history', history);
  //   const hash = history.location.hash;
  //   if (hash) {
  //     scrollToElement(hash, { offset: -120 });
  //   }
  // };

  // useEffect(() => {
  //   jumpToHash();
  // });
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));

  return (
    <Page wrapperStyles={classes.pageWrapper} hasContainer={false}>
      <div className={classes.mobileInfoContainer}>
        <Container hasInnerPadding={true}>
          <Typography className={classes.mobileInfoHeadline} component="h4" variant="h4">
            Trusted Lost and Found Tags
          </Typography>
          <div className={classes.mobileInfoSplitContainer}>
            <div className={classes.mobileInfoLeftSide}>
              <Typography component="p" variant="body1" color="secondary" className={classes.mobileInfoCopy}>
                with tag stickers
                <br />
                starting at $9.95
              </Typography>
              <Button variant="contained" color="primary" component={Link} to="/item-review">
                Buy Now
              </Button>
            </div>
            <img className={classes.sticker} src={sticker} alt="Ownerfy sticker QR code" />
          </div>
        </Container>
      </div>
      <div className={classes.heroContent}>
        <div className={classes.heroLimiter}>
          <div className={classes.heroTextContainer}>
            <Container hasInnerPadding={false}>
              <div className={classes.taglineContainer}>
                <span className={classes.tagline}>Protect</span>
                <span className={classes.tagline}>Authenticate</span>
                <span className={clsx(classes.tagline, classes.lastTagline)}>Recover</span>
              </div>
              <Typography className={classes.heroHeadline} component="h1" variant="h2" align="left">
                Trusted Lost
                <br />
                and Found Tags
              </Typography>
              <div className={classes.heroButtons}>
                <Button variant="contained" color="primary" component={Link} to="/item-review">
                  Buy Now
                </Button>
                <MuiLink
                  component="button"
                  variant="body2"
                  onClick={() => setActiveModal('foundItem')}
                  className={classes.foundSomething}
                >
                  Found
                  <br /> Something?
                </MuiLink>
              </div>
              <Typography component="p" variant="body1" color="secondary">
                starting at $9.95
              </Typography>
            </Container>
          </div>
          <Typography className={classes.mobileHeroText} component="h4" variant="h4">
            Protect
            <br />
            Authenticate
            <br />
            Recover
          </Typography>
        </div>
        <img className={classes.heroImage} src={backPack} alt="find my tag from ownerfy" />
      </div>

      <div className={classes.explanationArea} id="how-it-works">
        <Container hasInnerPadding={true}>
          <div className={classes.explanationContainer}>
            <Typography className={classes.explanationHeadline} component="h2" variant="h1" color="primary">
              How Ownerfy Works
            </Typography>

            <div className={classes.explanationGroup}>
              <div className={clsx(classes.explanationStep, classes.explanationStep1)}>
                <span className={classes.stepNumber}>1</span>
                <div className={classes.stepContent}>
                  <img
                    className={clsx(classes.explanationImage, classes.stackedLogo)}
                    src={stackedLogo}
                    alt="Stacked logo"
                  />
                  <p className={classes.explanationTitle}>Order Your Tag</p>
                  <p className={classes.explanationBody}>
                    Order your tag on our site, add a phone number or optional custom message.
                  </p>
                </div>
              </div>

              <div className={clsx(classes.explanationStep, classes.explanationStep2)}>
                <span className={classes.stepNumber}>2</span>
                <div className={classes.stepContent}>
                  <img
                    className={clsx(classes.explanationImage, classes.luggageTag)}
                    src={luggageTag}
                    alt="Luggage Tag"
                  />
                  <p className={classes.explanationTitle}>Attach the Ownerfy Tag</p>
                  <p className={classes.explanationBody}>
                    If the item gets lost and someone finds it they’ll be able to scan the tag and privately get in
                    touch with you, the owner.
                  </p>
                </div>
              </div>

              <div className={clsx(classes.explanationStep)}>
                <span className={classes.stepNumber}>3</span>
                <div className={classes.stepContent}>
                  <img className={clsx(classes.explanationImage, classes.qrCode)} src={qrCode} alt="QR code" />
                  <p className={classes.explanationTitle}>Update your tag anytime</p>
                  <p className={classes.explanationBody}>
                    Update your information on the web for all your tags any time.
                  </p>
                </div>
              </div>

              <div className={clsx(classes.explanationStep, classes.explanationStep4)}>
                <div className={classes.stepContent}>
                  <p className={classes.strongText}>
                    Protect your
                    <br />
                    valuables
                    <br />
                    today!
                  </p>
                  <div className={classes.registerTagButtonContainer}>
                    <Button variant="contained" color="primary" component={Link} to="/item-review">
                      Buy Now
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </div>

      <div className={classes.foundItemArea}>
        <Container hasInnerPadding={true}>
          <div id="found-item" className={classes.foundItemContainer}>
            <div className={classes.foundItemTextContainer}>
              <Typography className={classes.foundItemHeadline} component="h2" variant="h1">
                Found an Item with the <span className={classes.foundItemHeadlineEmphasis}>Ownerfy</span> Tag?
              </Typography>
              <Typography className={classes.foundItemBodyStrong}>Thank you for being a good samaritan!</Typography>
              <Typography className={classes.foundItemBody}>
                Returning the item to the owner could not be easier. Just scan the tag with your device's photo app or
                click below to enter the code. Then submit the form to contact the owner. Pat yourself on the back, all
                in all a good day!
              </Typography>
              <Button variant="contained" color="primary" onClick={() => setActiveModal('foundItem')}>
                Enter Code
              </Button>
            </div>
            <img
              className={classes.handWithPhone}
              data-src-mobile={stackedLogo}
              src={handWithPhone}
              alt="Hand with phone demonstrating how to use Ownerfy QR code scan"
            />
          </div>
        </Container>
      </div>
    </Page>
  );
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      setActiveModal: actions.setActiveModal,
      saveItemDraftInfo: actions.saveItemDraftInfo,
    },
    dispatch,
  );
}

function mapStateToProps({ itemDraft }) {
  return {
    itemDraft,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(pageStyles)(Home));
